import React from 'react';
import { Box, styled } from '@mui/material';
import { rgbaToHex } from 'lib/helpers';
import { RGBAValue } from 'lib/form/fields/ColorFormField';

const PREFIX = 'PerkPreviewThumbnail';

const classes = {
    background: `${PREFIX}-background`
};

const StyledBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.grey[400],
    borderBottom: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    [`& .${classes.background}`]: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%'
    }
}));

interface PerkPreviewThumbnailProps {
    backgroundImageUrl?: string;
    backgroundOverlayColour?: string;
    backgroundOverlayOpacity?: number;
}

export const PerkPreviewThumbnail: React.FC<PerkPreviewThumbnailProps> = ({
    backgroundImageUrl,
    backgroundOverlayColour,
    backgroundOverlayOpacity
}) => {
    const overlayColor = React.useMemo<RGBAValue | undefined>(() => {
        if (!backgroundOverlayColour) {
            return undefined;
        }
        const match = backgroundOverlayColour.match(/\d+/g);
        if (!match) {
            return undefined;
        }
        const [r, g, b] = match;
        return {
            r: Number(r),
            g: Number(g),
            b: Number(b),
            a: Number(backgroundOverlayOpacity) || 0
        };
    }, [backgroundOverlayColour, backgroundOverlayOpacity]);

    return (
        <StyledBox>
            {backgroundImageUrl && (
                <img
                    className={classes.background}
                    src={backgroundImageUrl}
                    alt=""
                    style={{ objectFit: 'cover' }}
                />
            )}
            {overlayColor && (
                <div
                    className={classes.background}
                    style={{ backgroundColor: rgbaToHex(overlayColor, true) }}
                />
            )}
        </StyledBox>
    );
};
